<!-- MODULO ALLEGATI -->
<div class="container mb-5 modulo allegati">
  <div class="row">
    <div class="col-12" *ngIf="campi.ALLEGATI">
      <div class="box-allegato text-center mr-2 mb-3" *ngFor="let allegato of campi.ALLEGATI?.valore" (click)="download(allegato)">
        <div class="fas fa-download"></div>
        <p class="small text-muted mb-0">{{allegato.nomeFile}}</p>
      </div>
    </div>        
  </div>
</div>
<!-- //MODULO ALLEGATI -->